import { jsx as _jsx } from "react/jsx-runtime";
import { createCustomBlockSpec } from '../../routines/createCustomBlockSpec.js';
import { Divider as DividerElement } from '@mantine/core';
export const Divider = createCustomBlockSpec({
    content: 'none',
    propSchema: {},
    type: 'divider',
}, {
    render: () => {
        return (_jsx(DividerElement, { my: "md", w: "100%" }));
    },
    toExternalHTML: () => {
        return _jsx("hr", {});
    },
});
//# sourceMappingURL=Divider.js.map